/**
 * LoginPortal standalone entry point.
 * Fuentes/iconos empaquetados (sin CDN) — Tiger WebView corporativo suele bloquear jsdelivr.
 */
import '@fontsource/lato/400.css';
import '@fontsource/lato/700.css';
import '@fontsource/lato/900.css';
import 'bootstrap-icons/font/bootstrap-icons.css';
import React from 'react';
import { createRoot } from 'react-dom/client';
import { ThemeProvider } from './contexts/ThemeContext';
import LoginPortalPage from './LoginPortalPage.jsx';
import PoliticaPrivacidadPage from './pages/PoliticaPrivacidadPage.jsx';
import LoginPortalErrorBoundary from './components/LoginPortalErrorBoundary.jsx';
import './styles/LoginPortal.css';

/** Path pública (root o prefijo /login-portal en lab). */
function isPoliticaPrivacidadPath(pathname) {
  const p = String(pathname || '').replace(/\/+$/, '') || '/';
  return p === '/politica-privacidad' || p.endsWith('/politica-privacidad');
}

function renderBootFailure(message) {
  const root = document.getElementById('root');
  if (!root) return;
  root.innerHTML = '';
  const panel = document.createElement('div');
  panel.setAttribute('role', 'alert');
  panel.style.cssText = [
    'min-height:100vh',
    'display:flex',
    'flex-direction:column',
    'align-items:center',
    'justify-content:center',
    'padding:24px',
    'font-family:Lato,sans-serif',
    'text-align:center',
    'color:#28466D',
  ].join(';');
  panel.innerHTML = `<p style="margin:0 0 12px;font-weight:700">No se pudo iniciar LoginPortal</p><p style="margin:0;max-width:320px">${message}</p>`;
  root.appendChild(panel);
}

try {
  const mountNode = document.getElementById('root');
  if (!mountNode) {
    throw new Error('Contenedor #root no encontrado.');
  }
  const pathname = typeof window !== 'undefined' ? window.location.pathname : '/';
  const Page = isPoliticaPrivacidadPath(pathname)
    ? PoliticaPrivacidadPage
    : LoginPortalPage;

  const root = createRoot(mountNode, {
    onUncaughtError(error, errorInfo) {
      if (typeof console !== 'undefined') {
        console.error('[LoginPortal] onUncaughtError', error, errorInfo);
      }
      try {
        document.documentElement.setAttribute('data-tiger-app-state', 'error');
      } catch {
        /* ignore */
      }
    },
  });
  root.render(
    <React.StrictMode>
      <LoginPortalErrorBoundary>
        <ThemeProvider>
          <Page />
        </ThemeProvider>
      </LoginPortalErrorBoundary>
    </React.StrictMode>,
  );
  try {
    document.documentElement.setAttribute('data-tiger-app-state', 'ready');
  } catch {
    /* ignore */
  }
} catch (err) {
  const msg = err instanceof Error ? err.message : 'Error desconocido al cargar la app.';
  renderBootFailure(msg);
  try {
    document.documentElement.setAttribute('data-tiger-app-state', 'error');
  } catch {
    /* ignore */
  }
  if (typeof console !== 'undefined') {
    console.error('[LoginPortal] boot failed', err);
  }
}
